/*
 * The closing band is a flat plum panel by design — the mockup backed it with a mingle
 * photo, but that was dropped: the page already carries five photographs above this point.
 */
const WelcomeBand = () => (
	<section className='hx-welcome hx-bleed'>
		<div className='hx-welcome__scrim' />
		<div className='hx-wrap hx-welcome__inner'>
			<div>
				<h2>
					Varmt välkommen till
					<br />
					Harmoni Expo!
				</h2>
				<p>24–25 oktober 2026 • Solnahallen, Stockholm</p>
			</div>
			<div className='hx-welcome__seal'>
				<span>Upptäck</span>
				<span>Upplev</span>
				<span>Inspireras</span>
			</div>
		</div>
	</section>
)

export default WelcomeBand
